import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from './plugins/axios'
import VueAxios from 'vue-axios'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import dayjs from 'dayjs'
import 'dayjs/locale/ko'

dayjs.locale('ko') // global로 한국어 locale 사용

const app = createApp(App)
app.use(store)
app.use(router)
app.use(VueAxios, axios)
app.provide('axios', app.config.globalProperties.axios)
app.use(Antd)
app.config.globalProperties.$dayjs = dayjs
app.config.globalProperties.$ymdFormat = 'YYYY-MM-DD'
app.config.globalProperties.$filters = {
  makeComma (input) { // 백단위 숫자 콤마 찍기
    if (!input) {
      return ''
    }

    return String(input).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  },

  fixedFormat (input) { // 백단위 숫자 콤마 찍기
    if (!input) {
      return ''
    }

    return input.toFixed(1)
  },

  filterOption (input, option) { // selectBox search
    return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
  },

  dayFormat (input) { // 날짜 포맷팅
    if (!input) {
      return null
    }

    return dayjs(input).format('YYYY-MM-DD')
  },

  telNoFormat (input) { // 연락처 포맷팅
    const replacedInput = input.replace(/\D/g, '').match(/(\d{0,3})(\d{0,4})(\d{0,4})/)
    return !replacedInput[2] ? replacedInput[1] : replacedInput[1] + '-' + replacedInput[2] + (replacedInput[3] ? '-' + replacedInput[3] : '')
  },

  mblTelNoFormat (input) { // 휴대폰 포맷팅
    const replacedInput = input.replace(/\D/g, '').match(/(\d{0,3})(\d{0,4})(\d{0,4})/)
    return !replacedInput[2] ? replacedInput[1] : replacedInput[1] + '-' + replacedInput[2] + (replacedInput[3] ? '-' + replacedInput[3] : '')
  },

  getRowSpans (arr, key) { // rowspan
    let sameValueLength = 0
    const rowSpans = []

    for (let i = arr.length - 1; i >= 0; i--) {
      if (i === 0) {
        rowSpans[i] = sameValueLength + 1
        continue
      }

      if (arr[i][key] !== '' && arr[i][key] === arr[i - 1][key]) {
        rowSpans[i] = 0
        sameValueLength++
      } else {
        rowSpans[i] = sameValueLength + 1
        sameValueLength = 0
      }
    }

    return rowSpans
  },

  getRowSpans2 (arr, key, key2) { // rowspan
    let sameValueLength = 0
    const rowSpans = []

    for (let i = arr.length - 1; i >= 0; i--) {
      if (i === 0) {
        rowSpans[i] = sameValueLength + 1
        continue
      }

      if (arr[i][key] !== '' && arr[i][key2] !== '' && arr[i][key] === arr[i - 1][key] && arr[i][key2] === arr[i - 1][key2]) {
        rowSpans[i] = 0
        sameValueLength++
      } else {
        rowSpans[i] = sameValueLength + 1
        sameValueLength = 0
      }
    }

    return rowSpans
  },

  getRowSpans3 (arr, key, key2, key3) { // rowspan
    let sameValueLength = 0
    const rowSpans = []

    for (let i = arr.length - 1; i >= 0; i--) {
      if (i === 0) {
        rowSpans[i] = sameValueLength + 1
        continue
      }

      if (arr[i][key] !== '' && arr[i][key2] !== '' && arr[i][key3] !== '' && arr[i][key] === arr[i - 1][key] && arr[i][key2] === arr[i - 1][key2] && arr[i][key3] === arr[i - 1][key3]) {
        rowSpans[i] = 0
        sameValueLength++
      } else {
        rowSpans[i] = sameValueLength + 1
        sameValueLength = 0
      }
    }

    return rowSpans
  }
}

app.config.productionTip = false

app.mount('#app')
